import { SortData } from '../sort';

export enum ListStateFields {
  TYPE_GROUP = 'typeGroup',
  FILTERS = 'filters',
  SORTING = 'sorting',
  QUERY = 'query'
}

export interface ListStateParams {
  typeGroup?: string;
  filters?: { [key: string]: unknown };
  sorting?: SortData;
  query?: string;
}
